module.exports = __webpack_public_path__ + "static/media/visa-white.8d06fe69.svg";